// React
import { useContext } from "react"

// Components
import { ActionButton, Button, Modal } from "components"
import { FormSection } from "./FormSection"

// Contexts
import { DeleteContext } from "../contexts"

// Form
import { FormProvider, useForm } from "react-hook-form"

// Third-Party Libraries
import toast from "react-hot-toast"

// Types
import type { FormType } from "../utils"

// Utils
import { useApi, useToggle } from "utils"

export function Delete(): JSX.Element {
  // Hooks
  const { isActive, toggle } = useToggle(false)

  return (
    <>
      <ActionButton.Delete className="join-item" onClick={toggle} />
      {isActive && <ModalSection toggle={toggle} />}
    </>
  )
}

function ModalSection(params: {
  toggle: () => void
}): JSX.Element {
  // Vars
  const toggle = params.toggle

  // Hooks
  const api = useApi()
  const { data, refetch } = useContext(DeleteContext)

  // Form
  const defaultValues: FormType = {
    file_name: data.file_name,
    description: data.file_description
  }
  const methods = useForm<FormType>({
    defaultValues
  })
  const onSubmit = (value: FormType): Promise<void> => {
    return new Promise<void>((resolve) => {
      toast.promise(
        api.delete(
          `/import_coa/delete_by_filename`,
          { params: { file_name: data.file_name } }
        ),
        {
          loading: "Loading...",
          success: (res) => res.data.message,
          error: (err) => err.response.data.message
        }
      ).then(() => {
        toggle()
        refetch()
      }).catch(() => {
      }).finally(() => {
        resolve()
      })
    })
  }

  return (
    <Modal
      isOpen
      title="DELETE ACCOUNT IMPORT"
      closeModal={toggle}
    >
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <Modal.Body>
            <h5 className="text-error">Are you sure want to delete this data?</h5>

            <FormSection
              disabled
              date={data.transaction_date}
            />
          </Modal.Body>

          <Modal.Footer className="text-end">
            <Button
              type="submit"
              color="error"
              loading={methods.formState.isSubmitting ? "true" : undefined}
            >
              Delete
            </Button>
          </Modal.Footer>
        </form>
      </FormProvider>
    </Modal>
  )
}